import React from "react";


import { useNavigate } from "react-router-dom";
import Highlighter from "react-highlight-words";
import { SearchOutlined } from "@ant-design/icons";
import { useRef, useState } from "react";
import { Table, Button, Space, Tooltip, Input } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";


function GroupList({ groups, loading, openDeleteModal }) {
  const navigate = useNavigate();
  const searchInput = useRef(null);
  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");



  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={searchInput}
          placeholder="Buscar"
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => {
            confirm();
            setSearchText(selectedKeys[0]);
            setSearchedColumn(dataIndex);
          }}
          style={{ marginBottom: 8, display: "block" }}
        />

        <Space>
          <Button
            type="primary"
            size="small"
            icon={<SearchOutlined />}
            style={{ width: 90 }}
            onClick={() => {
              confirm();
              setSearchText(selectedKeys[0]);
              setSearchedColumn(dataIndex);
            }}
          >
            Buscar
          </Button>

          <Button
            size="small"
            style={{ width: 90 }}
            onClick={() => {
              clearFilters && clearFilters();
              setSearchText("");
            }}
          >
            Reiniciar
          </Button>
        </Space>
      </div>
    ),

    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1677ff" : undefined }} />
    ),

    onFilter: (value, record) => {
      const text = record[dataIndex];
      return text
        ? text.toString().toLowerCase().includes(value.toLowerCase())
        : false;
    },

    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });

  const columns = [
    {
      title: "Nome do Grupo",
      dataIndex: "name",
      key: "name",
      align: "left",
      ...getColumnSearchProps("name"),
      sorter: (a, b) => (a.name || "").localeCompare(b.name || ""),
    },

    {
      title: "Descrição",
      dataIndex: "description",
      key: "description",
    },

    {
      title: "Ativo",
      dataIndex: "active",
      key: "active",
      align: "center",
      filters: [
        { text: "Sim", value: true },
        { text: "Não", value: false },
      ],
      onFilter: (value, record) => record.active === value,
      sorter: (a, b) => Number(a.active) - Number(b.active),
      render: (active) => (active ? "Sim" : "Não"),
    },

    {
      title: "Ações",
      key: "acoes",
      align: "start",
      render: (_, record) => (
        <Space>
          <Tooltip title="Editar">
            <Button
              type="link"
              icon={<EditOutlinedIcon />}
              onClick={(e) => {
                e.stopPropagation();
                navigate(`/group/edit/${record.id}`);
              }}
            />
          </Tooltip>

          <Tooltip title="Excluir">
            <Button
              type="link"
              danger
              icon={<DeleteOutlinedIcon />}
              onClick={(e) => {
                e.stopPropagation();
                openDeleteModal({
                  id: record.id,
                  name: record.name,
                });
              }}
            />
          </Tooltip>
        </Space>
      ),
    },
  ];


  return (
    <>
      {/* Cabeçalho */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-start", // topo
          marginBottom: 24,
        }}
      >
        <h2 style={{ color: "var(--fortio-primary)", margin: 0 }}>
          Listagem de Grupos
        </h2>

        <Button

          id="ButtonHover"
          type="primary"
          icon={<PlusOutlined />}
          onClick={() => navigate("/group/new")}
          style={{ marginRight: 200 }}
        >
          Novo
        </Button>
      </div>
      {/* Tabela */}
      <Table
        rowKey="id"
        columns={columns}
        dataSource={groups}
        loading={loading}
        pagination={{ pageSize: 10 }}
      />
    </>
  );
}

export default GroupList;
